export const HSCS_LOAD = 'HSCS_LOAD';
export const HSCS_LOAD_SUCCESS = 'HSCS_LOAD_SUCCESS';
export const HSCS_LOAD_ERROR = 'HSCS_LOAD_ERROR';
export const HSCS_ADD = 'HSCS_ADD';
export const HSCS_ADD_SUCCESS = 'HSCS_ADD_SUCCESS';
export const HSCS_ADD_ERROR = 'HSCS_ADD_ERROR';
export const HSCS_UPDATE = 'HSCS_UPDATE';
export const HSCS_UPDATE_SUCCESS = 'HSCS_UPDATE_SUCCESS';
export const HSCS_UPDATE_ERROR = 'HSCS_UPDATE_ERROR';
export const HSCS_DELETE = 'HSCS_DELETE';
export const HSCS_DELETE_SUCCESS = 'HSCS_DELETE_SUCCESS';
export const HSCS_DELETE_ERROR = 'HSCS_DELETE_ERROR';

export const HSC_UPDATE = 'HSC_UPDATE';
export const HSC_UPDATE_SUCCESS = 'HSC_UPDATE_SUCCESS';
export const HSC_UPDATE_ERROR = 'HSC_UPDATE_ERROR';
export const HSC_DELETE = 'HSC_DELETE';
export const HSC_DELETE_SUCCESS = 'HSC_DELETE_SUCCESS';
export const HSC_DELETE_ERROR = 'HSC_DELETE_ERROR';
